import * as Yup from 'yup';
import { RoleDto } from '../../common/dtos/role.dtos';

export interface UserDto {
    id?: string,
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber?: string,
    isActive: boolean,
    roles?: RoleDto[]
}

export const userInit: UserDto = {
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  isActive: true
}

export const userValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("A first name is required"),
  lastName: Yup.string().required("A last name is required"),
  email: Yup.string().email('Invalid email address').required("An email is required"),
});